import { BehaviorSubject } from 'rxjs';

export const currentUserSubject = new BehaviorSubject(
	localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).access : null
);

export const authenticationService = {
	currentUser: currentUserSubject.asObservable(),
	get currentUserValue() {
		return currentUserSubject.value;
	}
};
